import React from 'react';
import { Menu } from 'antd';
import { UnorderedListOutlined, BarChartOutlined, PlusOutlined, AppstoreOutlined, UserOutlined } from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import './MobileBottomMenu.scss';

const MobileBottomMenu = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Determine which menu item should be highlighted based on current path
  const getSelectedKey = () => {
    const pathname = location.pathname;
    
    // Products pages
    if (pathname.startsWith('/products') || pathname.startsWith('/import-products') || pathname.startsWith('/search-product') || pathname.startsWith('/product/')) {
      return 'products';
    }
    
    // Lists pages - highlight "Liste necesar" (create-list) for all list pages
    if (pathname.startsWith('/liste-necesar') || 
        pathname.startsWith('/gata-de-trimis') || 
        pathname.startsWith('/liste-in-ofertare') || 
        pathname.startsWith('/liste-ofertate') || 
        pathname.startsWith('/liste-arhivate') ||
        pathname.startsWith('/lists/')) {
      return 'create-list';
    }
    
    return '';
  };

  const selectedKey = getSelectedKey();

  const menuItems = [
    {
      key: 'products',
      label: (
        <div className="menu-item">
          <UnorderedListOutlined />
          <span>Products</span>
        </div>
      ),
      onClick: () => navigate('/products'),
    },
    {
      key: 'reports',
      label: (
        <div className="menu-item">
          <BarChartOutlined />
          <span>Rapoarte</span>
        </div>
      ),
      // No navigation for reports
      onClick: () => {},
    },
    {
      key: 'create-list',
      label: (
        <div className="menu-item">
          <PlusOutlined />
          <span>Liste necesar</span>
        </div>
      ),
      onClick: () => navigate('/liste-necesar'),
    },
    {
      key: 'lists',
      label: (
        <div className="menu-item">
          <AppstoreOutlined />
          <span>Liste</span>
        </div>
      ),
      // No navigation for lists
      onClick: () => {},
    },
    {
      key: 'account',
      label: (
        <div className="menu-item">
          <UserOutlined />
          <span>Cont</span>
        </div>
      ),
      // No navigation for account
      onClick: () => {},
    },
  ];

  return (
    <div className="mobile-bottom-menu standard__only-mobile">
      <Menu
        mode="horizontal"
        className="bottom-menu"
        selectedKeys={selectedKey ? [selectedKey] : []}
        items={menuItems}
        style={{ display: 'flex', justifyContent: 'space-around', border: 'none' }}
      />
    </div>
  );
};

export default MobileBottomMenu;